module.exports = __webpack_public_path__ + "img/chad.e0ab750.webp";